import { Button, type ButtonProps } from "react-bootstrap";
import { MdSave } from "react-icons/md";

const SaveButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="primary" {...(props as ButtonProps)}>
    <MdSave /> {children}
  </Button>
);

export default SaveButton;
